import getRepoDocuments from 'api/v2/repository/getRepoDocuments';
import { Sort } from 'components/atoms/Table/table.types';
import { useRepoFiltersStore } from 'hooks/DocumentsRepository/useDocumentsRepositoryFilters';
import useTableQuery from 'hooks/tableQuery/useTableQuery';
import { useEffect } from 'react';
import tableState from 'store/tableState/tableState.store';
import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';

const { filtersData } = useRepoFiltersStore.getState();
const useTableState = tableState({
  filtersData,
  tableSorter: { cellId: 'file.name', direction: Sort.desc },
});
const useDocuments = () => {
  const tableState = useTableState();

  useEffect(() => {
    return useRepoFiltersStore.subscribe(({ filtersData }) => {
      tableState.controllers.setFiltersData(filtersData);
    });
  }, []);

  return useTableQuery({
    tableState,
    cacheKey: DocumentsRepositoryCacheKeys.DocumentsList,
    onFetch: (params) => {
      return getRepoDocuments({ ...params, perPage: 15 });
    },
  });
};

export default useDocuments;
